<script lang="ts">
    interface Props {
        target: number;
        suffix?: string;
        decimals?: number;
        duration?: number;
        class?: string;
    }

    let {
        target,
        suffix = '',
        decimals = 0,
        duration = 1800,
        class: className = ''
    }: Props = $props();

    let display = $state(`0${suffix}`);
    let el: HTMLSpanElement;

    $effect(() => {
        if (!el) return;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const start = performance.now();
                        function update(now: number) {
                            const elapsed = now - start;
                            const progress = Math.min(elapsed / duration, 1);
                            const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
                            const value = target * eased;
                            display = value.toFixed(decimals) + suffix;
                            if (progress < 1) requestAnimationFrame(update);
                            else display = target.toFixed(decimals) + suffix;
                        }
                        requestAnimationFrame(update);
                        observer.unobserve(el);
                    }
                });
            },
            { threshold: 0.5 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    });
</script>

<span bind:this={el} class={className}>{display}</span>
